"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_popper_1 = require("react-popper");
const classnames_1 = __importDefault(require("classnames"));
const Typography_1 = require("../Typography/Typography");
function Tooltip({ children, placement = 'top', variant = 'dark', tooltipText }) {
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const onMouseEnter = () => setShowTooltip(true);
    const onMouseLeave = () => setShowTooltip(false);
    return ((0, jsx_runtime_1.jsxs)(react_popper_1.Manager, { children: [(0, jsx_runtime_1.jsx)(react_popper_1.Reference, { children: ({ ref }) => ((0, jsx_runtime_1.jsx)("span", Object.assign({ ref: ref, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, { children: children }))) }), showTooltip && ((0, jsx_runtime_1.jsx)(react_popper_1.Popper, Object.assign({ placement: placement, modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 16]
                        }
                    },
                    {
                        name: 'arrow',
                        options: {
                            padding: 5
                        }
                    }
                ] }, { children: ({ ref, style, placement, arrowProps }) => ((0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: ref, style: style, className: (0, classnames_1.default)('px-2', 'py-1', 'rounded', 'z-10', {
                        'bg-black text-white': variant === 'dark',
                        'bg-white text-black drop-shadow': variant === 'light'
                    }) }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Typography, Object.assign({ variant: "h100" }, { children: tooltipText })), (0, jsx_runtime_1.jsx)("div", Object.assign({}, arrowProps, { "data-placement": placement, className: (0, classnames_1.default)('border-[transparent]', 'absolute', 'before:border-[9px]', 'before:border-solid', 'before:border-[transparent]', 'before:absolute', 'before:-z-10', 'before:content-[""]', {
                                // Top Placement
                                'bottom-0 !left-[-9px]': placement.startsWith('top'),
                                'before:border-t-black': placement.startsWith('top') && variant === 'dark',
                                'before:border-t-white': placement.startsWith('top') && variant === 'light',
                                // Bottom Placement
                                '-top-4 !left-[-9px]': placement.startsWith('bottom'),
                                'before:border-b-black': placement.startsWith('bottom') && variant === 'dark',
                                'before:border-b-white': placement.startsWith('bottom') && variant === 'light',
                                // Left Placement
                                'right-0 !top-[-0.5rem]': placement.startsWith('left'),
                                'before:border-l-black': placement.startsWith('left') && variant === 'dark',
                                'before:border-l-white': placement.startsWith('left') && variant === 'light',
                                // Right Placement
                                'left-[-1rem] !top-[-0.5rem]': placement.startsWith('right'),
                                'before:border-r-black': placement.startsWith('right') && variant === 'dark',
                                'before:drop-shadow before:border-r-white': placement.startsWith('right') && variant === 'light'
                            }) }))] }))) })))] }));
}
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map